<template>
  <div class="table-box">
    <!--查询-->
    <div class="search-box">
      <div style="display:flex;flex-direction:column;align-items:baseline">
        <el-button
          type="success"
          @click="add"
          class="addBtn"
          icon="el-icon-plus"
        >
          新建资讯
        </el-button>
        <br />
        <div>
          <span>资讯名称：</span>
          <el-input
            class="search-input"
            v-model="searchQuery.title"
            placeholder="请输入关键字"
            clearable
          ></el-input>
          <el-button type="primary" @click="searchEvent">搜索</el-button>
        </div>
      </div>
    </div>
    <!--列表-->
    <div class>
      <el-table
        v-loading="loading"
        :data="tableData"
        border
        style="width: 100%"
        :stripe="true"
        :highlight-current-row="false"
      >
        <el-table-column
          type="index"
          label="序号"
          align="center"
          width="80"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="title"
          label="资讯"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="author"
          label="资讯作者"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          label="更新时间"
        >
          <template slot-scope="scope">
            {{ scope.row.updateDt | transAllTime }}
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          label="状态"
        >
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.status > 0"
              type="text"
              size="small"
              @click="checkStatus(scope.row)"
            >
              已关联
            </el-button>
            <span v-else>未关联</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="250" align="center">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="goDistDetail(scope.row)"
            >
              编辑
            </el-button>
            <el-button type="text" size="small" @click="del(scope)">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <!--分页-->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-sizes="[15, 60, 100]"
        :current-page="paginationData.pageNum"
        :total="totalElements"
        :page-size="paginationData.pageSize"
        layout="total, prev, pager, next, sizes, jumper"
        style="padding:15px"
      ></el-pagination>
    </div>
    <link-detail v-if="showDetail" :linkId="linkId" />
  </div>
</template>
<script>
//   import datePicker from "@/Mixin/datePicker";
import { information } from '@/api/ajax';
import { pageInation } from '@/Mixin/listMixin';
import linkDetail from './components/linkDetail.vue';
export default {
  mixins: [pageInation],
  data() {
    return {
      showDetail: false,
      getList: information.informationList, // 获取列表的AJAX
      searchQuery: {
        title: ''
      },
      linkId: ''
    };
  },
  components: {
    linkDetail
  },
  computed: {},
  methods: {
    checkStatus(row) {
      //查看关联
      this.linkId = row.id;
      this.showDetail = true;
    },
    add() {
      this.$router.push({
        path: '/information/detail'
      });
    },
    del(scope) {
      //删除
      let delEvent = scope => {
        let { row } = scope;
        information
          .deleteInformationVideo({
            id: row.id
          })
          .then(() => {
            this.$notify({
              title: '成功',
              message: '删除成功',
              type: 'success'
            });
            this.initWatchRouteChange();
          });
      };
      this.$makeSure(delEvent, scope, '是否确认删除');
    },
    goDistDetail(row) {
      this.$router.push({
        path: '/information/detail',
        query: {
          id: row.id
        }
      });
    }
  },
  filters: {
    transStatus() {}
  },
  created() {}
};
</script>

<style lang="scss" scoped>
.table-box {
  margin: 0;
  padding: 25px 15px;
}
</style>
